import React, { useState, useEffect, useContext } from 'react'
import AuthContext from '../context/AuthContext'
import { fetchScreeningLogs } from '../util/screeningLogs'
import { fetchBranches } from '../util/branches'
import { logout } from '../util/session'
import ReactLoading from 'react-loading'

const ReportIndex = (props) => {

    const [logs, setLogs] = useState([])
    const [branches, setBranches] = useState([])
    const [filters, setFilters] = useState({
        branchFilter: 'all',
        startDate: null,
        endDate: null,
        page: 1
    })
    const [pagination, setPagination] = useState({
        start: 1,
        end: 20,
        count: null
    })
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const {loggedIn, currentUser } = useContext(AuthContext)

    useEffect(() => {
        setLoading(true)
        fetchScreeningLogs(filters).then(({data}) => {
            setLogs(data.logs)
            setPagination({...pagination, count: data.count})
        })
        .catch(err => setError('ERROR: UNAUTHORIZED'))
        .finally(() => setLoading(false))
    }, [filters])

    useEffect(() => {
        fetchBranches().then(({data}) => setBranches(data))
    }, [])
  

    const handleChange = (e) => {
        setFilters({...filters, branchFilter: e.target.value, page: 1})
        setPagination({...pagination, start: 1, end: 20})
    }

    const logoutUser = () => {
        logout().then(() => props.history.push('/admin'))
    }

    const { start, end, count } = pagination
    const { page } = filters
    
    const handlePageChange = (query) => {
        let change = query == 'prev' ? -20 : 20
        if (query === 'prev') {
            let button = document.getElementById('prev-button')
            if (button.classList.contains('disabled')) return
            setFilters({...filters, page: page-1})
        } else {
            let button = document.getElementById('next-button')
            if (button.classList.contains('disabled')) return
            setFilters({...filters, page: page + 1})
        }
        setPagination({start: start + change, end: end + change})
    }

    if (error) return (
        <div className="alert alert-danger" role="alert" style={{marginTop: "10px"}}>
            {error}
        </div>
    )

    return (
        <div>
            <nav class="navbar navbar-light bg-light" style={{marginBottom: '10px'}}>
                <span class="navbar-brand mb-0 h1" style={{marginLeft: '3%'}}>COVID SCREENING LOG</span>
                <button onClick={logoutUser} type="button" class="btn btn-secondary">Log out</button>
            </nav>
            <select onChange={(e) => handleChange(e)} class="form-control" style={{marginBottom: "10px", marginLeft: '5%'}}>
                <option disabled selected>Filter by Branch</option>
                <option value='all'>All</option>
                {
                    branches.map(branch => (
                        <option value={branch._id}>{branch.name}</option>
                    ))
                }
            </select>
            <div style={{marginLeft: '5%', marginBottom: '10px'}}>
                <p>Filter by Date:</p>
                <span>From: </span><input style={{marginRight: '10px'}} type='date' onChange={(e) => setFilters({...filters, startDate: e.target.value})} />
                <span>To: </span><input type='date' onChange={(e) => setFilters({...filters, endDate: e.target.value})}></input>
                <a href='' onClick={(e) => setFilters({branchFilter: 'all', startDate: null, endDate: null})}> Reset filters</a>
            </div>
            <table className="table" style={{marginLeft: '5%', marginRight: '5%'}}>
                <thead>
                    <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Branch</th>
                    <th scope="col">Sent</th>
                    </tr>
                </thead>
                {loading ? <div className='loading'><ReactLoading type={'spin'} color={'black'}/></div>:
                <tbody>
                    {
                        logs.map(log => (
                            <tr>
                                <td>{log.name}</td>
                                <td>{log.branch.name}</td>
                                <td>{new Date(log.sent).toLocaleString()}</td>
                            </tr>
                        ))
                    }
                </tbody>}
            </table>

            <ul class="pagination" className="pagination" >
                <li id='prev-button' onClick={() => handlePageChange('prev')} class={`page-item ${start === 1 ? 'disabled' : null}`}><a class="page-link" href="#">Previous</a></li>
                <li class="page-item"><a class="page-link">{start} to {end >= count ? count : end} of {count}</a></li>
                <li id='next-button' onClick={() => handlePageChange('next')} class={`page-item ${end >= count ? 'disabled' : null}`}><a class="page-link" href="#">Next</a></li>
            </ul>
        </div>
    )
}

export default ReportIndex